module.exports = __webpack_public_path__ + "static/media/Song of the Butterflies - Strings Version.2037ada2.jpg";